import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import NavBar from '../components/NavBar'
import ViewVouchers from '../components/ViewVouchers'

const VoucherList = () => {
    return (
        <div>
        <Header />
        <NavBar />
            <ViewVouchers />
            <Footer/>
        </div>
    )
}

export default VoucherList
